import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=dc0c92be&scoped=true"
import script from "./Org.vue?vue&type=script&lang=js"
export * from "./Org.vue?vue&type=script&lang=js"
import style0 from "./Org.vue?vue&type=style&index=0&id=dc0c92be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c92be",
  null
  
)

export default component.exports